// extracted by mini-css-extract-plugin
export var mainBlockItem = "main-blocks-module--mainBlockItem--452b4";
export var mainBlocks = "main-blocks-module--mainBlocks--b9d3e";
export var mainBlocksCard = "main-blocks-module--mainBlocksCard--a4ad8";
export var mainBlocksHeader = "main-blocks-module--mainBlocksHeader--45346";